import React from "react";
import setDate from "../../utils/setDate";
import convertToCurrency from "../../utils/convertToCurrency";

const RevenueItemsSearchTable = () => {
    return [
        {
            id: 'date-created',
            title: 'Date Created',
            enabled: true,
            data: (revenueItem) => (
                <>
                    {setDate(revenueItem.dateCreated)}
                </>
            )
        },
        {
            id: 'date-modified',
            title: 'Date Modified',
            enabled: true,
            data: (revenueItem) => (
                <>
                    {setDate(revenueItem.dateModified)}
                </>
            )
        },
        {
            id: 'lead-date',
            title: 'Lead Date',
            enabled: true,
            data: (revenueItem) => (
                <>
                    {setDate(revenueItem.leadDate)}
                </>
            )
        },
        {
            id: 'billing-date',
            title: 'Billing Date',
            enabled: true,
            data: (revenueItem) => (
                <>
                    {setDate(revenueItem.billingDate)}
                </>
            )
        },
        {
            id: 'revenue-type',
            title: 'Revenue Type',
            enabled: true,
            data: (revenueItem) => (
                <>
                    {revenueItem.revenueType}
                </>
            )
        },
        {
            id: 'revenue-classification',
            title: 'Revenue Classification',
            enabled: true,
            data: (revenueItem) => (
                <>
                    {revenueItem.revenueClassification}
                </>
            )
        },
        {
            id: 'traffic-source-id',
            title: 'Traffic Source Id',
            enabled: false,
            data: (revenueItem) => (
                <>
                    {revenueItem.trafficSourceId}
                </>
            )
        },
        {
            id: 'affiliate-id',
            title: 'Affiliate Id',
            enabled: false,
            data: (revenueItem) => (
                <>
                    {revenueItem.affiliateId}
                </>
            )
        },
        {
            id: 'source-sub-code-1',
            title: 'Pub SubCode 2 / Origin',
            enabled: false,
            data: (revenueItem) => (
                <>
                    {revenueItem.sourceSubCode1}
                </>
            )
        },
        {
            id: 'source-sub-code-2',
            title: 'Pub SubCode 3 / Medium',
            enabled: false,
            data: (revenueItem) => (
                <>
                    {revenueItem.sourceSubCode2}
                </>
            )
        },
        {
            id: 'source-sub-code-3',
            title: 'Pub SubCode 1',
            enabled: false,
            data: (revenueItem) => (
                <>
                    {revenueItem.sourceSubCode3}
                </>
            )
        },
        {
            id: 'source-sub-code-4',
            title: 'Min Price',
            enabled: false,
            data: (revenueItem) => (
                <>
                    {revenueItem.sourceSubCode4 !== null ? convertToCurrency(revenueItem.sourceSubCode4) : 'N/A'}
                </>
            )
        },
        {
            id: 'source-sub-code-5',
            title: 'Source Lead Id / Loan Request Id',
            enabled: false,
            data: (revenueItem) => (
                <>
                    {revenueItem.sourceSubCode5}
                </>
            )
        },
        {
            id: 'billed',
            title: 'Amount Billed',
            enabled: true,
            alignment: 'right',
            data: (revenueItem) => (
                <>
                    {revenueItem.billed !== null ? convertToCurrency(revenueItem.billed) : 'N/A'}
                </>
            )
        },
        {
            id: 'billed-adjustment',
            title: 'Billed Adjustment',
            enabled: true,
            alignment: 'right',
            data: (revenueItem) => (
                <>
                    {revenueItem.billed !== null ? convertToCurrency(revenueItem.adjustmentTotalBilled) : 'N/A'}
                </>
            )
        },
        {
            id: 'payout',
            title: 'Amount Paid',
            enabled: true,
            alignment: 'right',
            data: (revenueItem) => (
                <>
                    {revenueItem.payout !== null ? convertToCurrency(revenueItem.payout) : 'N/A'}
                </>
            )
        },
        {
            id: 'payout-adjustment',
            title: 'Paid Adjustment',
            enabled: true,
            alignment: 'right',
            data: (revenueItem) => (
                <>
                    {revenueItem.payout !== null ? convertToCurrency(revenueItem.adjustmentTotalPayout) : 'N/A'}
                </>
            )
        },
        {
            id: 'adv-company-id',
            title: 'Advertiser Company Id',
            enabled: false,
            data: (revenueItem) => (
                <>
                    {revenueItem.advCompanyId}
                </>
            )
        },
        {
            id: 'adv1',
            title: 'Servicer / Revenue Event Type',
            enabled: true,
            data: (revenueItem) => (
                <>
                    {revenueItem.adv1}
                </>
            )
        },
        {
            id: 'adv2',
            title: 'Portfolio / Browser Id',
            enabled: true,
            data: (revenueItem) => (
                <>
                    {revenueItem.adv2}
                </>
            )
        },
        {
            id: 'adv3',
            title: 'Campaign / Field Id / Data Package Type',
            enabled: true,
            data: (revenueItem) => (
                <>
                    {revenueItem.adv3}
                </>
            )
        },
        {
            id: 'adv4',
            title: 'Loan Request Id / Revenue Id',
            enabled: false,
            data: (revenueItem) => (
                <>
                    {revenueItem.adv4}
                </>
            )
        },
        {
            id: 'adv5',
            title: 'adv5',
            enabled: false,
            data: (revenueItem) => (
                <>
                    {revenueItem.adv5}
                </>
            )
        },
        {
            id: 'loan-request-id',
            title: 'Loan Request Id',
            enabled: false,
            data: (revenueItem) => (
                <>
                    {revenueItem.laonRequestId}
                </>
            )
        },
        {
            id: 'loan-result-id',
            title: 'Loan Result Id',
            enabled: false,
            data: (revenueItem) => (
                <>
                    {revenueItem.loanResultId}
                </>
            )
        },
        {
            id: 'campaign-decision-log-id',
            title: 'Campaign Decision Log Id',
            enabled: false,
            data: (revenueItem) => (
                <>
                    {revenueItem.campaignDecisionLogId}
                </>
            )
        },
        {
            id: 'form-submit-id',
            title: 'Form Submit Id',
            enabled: false,
            data: (revenueItem) => (
                <>
                    {revenueItem.formId}
                </>
            )
        },
        {
            id: 'click-browser-id',
            title: 'Click Browser Id',
            enabled: false,
            data: (revenueItem) => (
                <>
                    {revenueItem.clickBrowserId}
                </>
            )
        },
        {
            id: 'form-field-submit-browser-id',
            title: 'Form Field Submit Browser Id',
            enabled: false,
            data: (revenueItem) => (
                <>
                    {revenueItem.formFieldSubmitBrowserId}
                </>
            )
        },
        {
            id: 'form-field-submit-field-id',
            title: 'Form Field Submit Field Id',
            enabled: false,
            data: (revenueItem) => (
                <>
                    {revenueItem.formFieldSubmitFieldId}
                </>
            )
        },
        {
            id: 'form-submit-browser-id',
            title: 'Form Submit Browser Id',
            enabled: false,
            data: (revenueItem) => (
                <>
                    {revenueItem.formSubmitBrowserId}
                </>
            )
        },
        {
            id: 'form-submit-data-package-type',
            title: 'Form Submit Data Package Type',
            enabled: false,
            data: (revenueItem) => (
                <>
                    {revenueItem.formSubmitDataPackageType}
                </>
            )
        },
        {
            id: 'everflow-status',
            title: 'Everflow Status',
            enabled: false,
            data: (revenueItem) => (
                <>
                    {revenueItem.everflowStatus}
                </>
            )
        },
        {
            id: 'everflow-status-expiration',
            title: 'Everflow Status Expiration',
            enabled: false,
            data: (revenueItem) => (
                <>
                    {revenueItem.everflowStatusExpiration}
                </>
            )
        },
        {
            id: 'everflow-affiliate-hash',
            title: 'Everflow Affiliate Hash',
            enabled: false,
            data: (revenueItem) => (
                <>
                    {revenueItem.everflowAffiliateHash}
                </>
            )
        },
        {
            id: 'everflow-offer-hash',
            title: 'Everflow Offer Hash',
            enabled: false,
            data: (revenueItem) => (
                <>
                    {revenueItem.everflowOfferHash}
                </>
            )
        },
        {
            id: 'everflow-transaction-id',
            title: 'Everflow Transaction Id',
            enabled: false,
            data: (revenueItem) => (
                <>
                    {revenueItem.everflowTransactionId}
                </>
            )
        },
        {
            id: 'everflow-conversion-id',
            title: 'Everflow Conversion Id',
            enabled: false,
            data: (revenueItem) => (
                <>
                    {revenueItem.everflowConversionId}
                </>
            )
        },
    ];
};

export default RevenueItemsSearchTable;
